const nameSpace = 'admin/campaign'

export const actions = {
  FETCH_INCOMPLETE_CAMPAIGN_LIST: `${nameSpace}/FETCH_INCOMPLETE_CAMPAIGN_LIST`,
  SET_COMPLETE: `${nameSpace}/SET_COMPLETE`,
  DELETE_CAMPAIGN: `${nameSpace}/DELETE_CAMPAIGN`,
  INIT: `${nameSpace}/INIT`,
}

export const getters = {
  loading: `${nameSpace}/loading`,
  incompleteCampaignList: `${nameSpace}/incompleteCampaignList`,
  incompleteCampaignCount: `${nameSpace}/incompleteCampaignCount`,
}
